import {connect} from "react-redux";

import MyTests from "../../components/UserCourse/MyTests";
import * as StudentActions from "../../store/actions/studentActions";
import * as RemindersActions from "../../store/actions/remindersActions";
import * as VideoActions from '../../store/actions/videoActions';

const mapStateToProps = (state) => ({
    ...state.reminders,
    ...state.auth,
    ...state.video,
    ...state.chat
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        
        dispatch(VideoActions.getUserCourseContent(courseId, token));
        dispatch(VideoActions.getCourseUser(profileId, token));
        dispatch(RemindersActions.getReminders());
    },
    getUserSubject: (profileId, subjectId, courseId, token) => {
        dispatch(VideoActions.getUserSubject(profileId, courseId, subjectId, token));
    },
    getUserContent: (profileId, courseId, courseUserId, token) => {
        dispatch(VideoActions.getTestCourse(courseId, token));
        dispatch(VideoActions.getUserLectureTests(courseUserId, token));
    },
    enrichTest: (id, token) => {
        dispatch(VideoActions.enrichTest(id, token));
    },
    enrichQuiz: (id, token) => {
        dispatch(VideoActions.enrichQuiz(id, token));
    },
    getLocation: () =>{
        dispatch(StudentActions.getLocationStudent())
    },
    getCurrentSubject: (subjectId, token) => {
        dispatch(VideoActions.getUserSubject(subjectId, token));
    },
    updateCourseUser: (cu, pid, token) => {
        dispatch(VideoActions.updateCourseUser(cu, pid, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyTests);


// WEBPACK FOOTER //
// ./src/containers/UserCourse/MyTestsContainer.js